import React from 'react';
import { Heading } from '../../components';

import classNames from 'classnames';
import css from '../../containers/ListingPage/ListingPage.module.css';

import {
  FaVideo,
  FaUserTie,
  FaShieldAlt,
  FaBed,
  FaPills,
  FaGripLines,
  FaLock,
  FaFireExtinguisher,
  FaUmbrellaBeach,
} from 'react-icons/fa';

import { GiBusDoors, GiFirstAidKit, GiPawHeart, GiSpikedFence } from 'react-icons/gi';
import { TbDeviceCctvFilled, TbDog } from 'react-icons/tb';
import { LuCctv } from "react-icons/lu";
import { LiaDoorOpenSolid } from "react-icons/lia";
import { ImExit } from "react-icons/im";
import { BsBoundingBoxCircles } from "react-icons/bs";


const safetyDisplayData = {
  cctv: { name: '24/7 CCTV Monitoring', icon: <LuCctv /> },
  live_cctv: { name: 'Live CCTV Feed', icon: <TbDeviceCctvFilled /> },
  staff_supervision: { name: '24/7 Staff Supervision', icon: <FaUserTie /> },
  fenced: { name: 'Fenced Property', icon: <GiSpikedFence /> },
  controlled: { name: 'Controlled Access Areas', icon: <FaShieldAlt /> },
  emergency_exits: { name: 'Emergency Exits', icon: <ImExit /> },
  fire_safety: { name: 'Fire Safety', icon: <FaFireExtinguisher /> },
  outdoor_zones: { name: 'Shaded/Weather-Protected Outdoor Zones', icon: <FaUmbrellaBeach /> },
  entry_exit: { name: 'Separate Entry/Exit for Pets', icon: <LiaDoorOpenSolid size={20} /> },
  first_aid: { name: 'Pet First Aid Kits', icon: <GiFirstAidKit /> },
  isolation_area: { name: 'Isolation Area for Sick Pets', icon: <BsBoundingBoxCircles /> },
  medication_services: { name: 'Medication Administration Services', icon: <FaPills /> }, 
  non_slip_floor: { name: 'Non-slip Flooring', icon: <FaGripLines /> }, 
  pet_restraints: { name: 'Pet Restraints', icon: <FaLock /> }, 
  outdoor_supervision: { name: 'Outdoor Play Area Supervision', icon: <FaUserTie /> },
};



const SectionSafetyFeatures = props => {
  const { heading, selectedOptions = [] } = props;

  if (!heading || selectedOptions.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionCleaningFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul className={css.topFacilitiesList}>
        {selectedOptions.map(option => {
          const facility = safetyDisplayData[option];
          return (
            <li key={option} className={css.multiEnumItem}>
              <span className={css.facilityIcon}>{facility?.icon}</span>
              <span>{facility?.name || option}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};


export default SectionSafetyFeatures;
